export const datesAreDiff = (moment1, moment2) =>
  moment1.toDate().getTime() !== moment2.toDate().getTime();


// WEBPACK FOOTER //
// ./src/utils/datesAreDiff.js